// @flow
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

import ModularUIRequest from "../modularui/ModularUIRequest";
import { getLocale } from "../redux/selectors/i18n";

import type { RequestModularUIOptions } from "../utils";
import type Href from "../models/href/Href";

const getModularUIRequest = createSelector([getLocale], (localeCode) => {
  return (href: Href, options?: $Shape<RequestModularUIOptions>) => {
    const request = new ModularUIRequest(href, options);
    request.locale = localeCode;
    return request;
  };
});

/**
 * Creates a ModularUIRequest with the locale as available in the redux store
 */
export const useModularUIRequest = (): ((
  href: Href,
  options?: $Shape<RequestModularUIOptions>,
) => ModularUIRequest) => useSelector(getModularUIRequest);
